export const COURSE_STRUCTURE_TYPE = {
  references: "Học liệu tham khảo",
  assessment: "Học liệu đánh giá",
  study: "Học liệu kiến thức",
} as any
